import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { loadingBarApiInjectionKey as v, loadingBarProviderInjectionKey as u } from "./context.js";
import f from "./LoadingBar.js";
import c from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/life-cycle/use-is-mounted.js";
import m from "../../_mixins/use-config.js";
import p from "../../_mixins/use-theme.js";
import { defineComponent as g, provide as s, h as a, Teleport as h, Fragment as B, nextTick as n } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as b } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const y = Object.assign(Object.assign({}, p.props), {
  to: {
    type: [String, Object, Boolean],
    default: void 0
  },
  containerClass: String,
  containerStyle: [String, Object],
  loadingBarStyle: {
    type: Object
  }
}), L = g({
  name: "LoadingBarProvider",
  props: y,
  setup(t) {
    const i = c(), r = b(null), l = {
      start() {
        var e;
        i.value ? (e = r.value) === null || e === void 0 || e.start() : n(() => {
          var o;
          (o = r.value) === null || o === void 0 || o.start();
        });
      },
      error() {
        var e;
        i.value ? (e = r.value) === null || e === void 0 || e.error() : n(() => {
          var o;
          (o = r.value) === null || o === void 0 || o.error();
        });
      },
      finish() {
        var e;
        i.value ? (e = r.value) === null || e === void 0 || e.finish() : n(() => {
          var o;
          (o = r.value) === null || o === void 0 || o.finish();
        });
      }
    }, {
      mergedClsPrefixRef: d
    } = m(t);
    return s(v, l), s(u, {
      props: t,
      mergedClsPrefixRef: d
    }), Object.assign(l, {
      loadingBarRef: r
    });
  },
  render() {
    var t, i;
    return a(B, null, a(h, {
      disabled: this.to === !1,
      to: this.to || "body"
    }, a(f, {
      ref: "loadingBarRef",
      containerStyle: this.containerStyle,
      containerClass: this.containerClass
    })), (i = (t = this.$slots).default) === null || i === void 0 ? void 0 : i.call(t));
  }
});
export {
  L as default,
  y as loadingBarProviderProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/loading-bar/src/LoadingBarProvider.js
// module id = 1664
// module chunks = 41